// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"1241c118","227":"3fe59131"}[chunkId] + ".chunk.js";
};